import { useEffect } from "react";
import { type SortColumn, type MailFolderTableQuery, type TableView } from "owa-mail-list-store";
import { useComputedValue } from "owa-react-hooks/lib/useComputed";
import addVirtualizedGroupHeadersAction from "../actions/addVirtualizedGroupHeadersAction";
import type GroupHeaderGenerator from "../type/GroupHeaderGenerator";

export default function useVirtualizedGroupHeaders(tableView: TableView, groupHeaderGenerator: GroupHeaderGenerator | null): void {
    const categoryGroupHeaderIds = useComputedValue(() => (tableView.tableQuery as MailFolderTableQuery).sortBy?.sortColumn === 14
        ? tableView.rowKeys.map(rowKey => groupHeaderGenerator?.getGroupHeader(rowKey, tableView).headerId)
        : null, [tableView, groupHeaderGenerator]);
    
    useEffect(() => {
        addVirtualizedGroupHeadersAction(tableView, false /* shouldReset */);
    }, [
        tableView.id,
        tableView.rowKeys.length,
        tableView.currentLoadedIndex,
        tableView.loadedStartIndex,
        tableView.reloadCount,
        tableView.rowPositionUpdatedCount,
        groupHeaderGenerator,
        categoryGroupHeaderIds,
    ]);
}
